<template>
    <v-card class="panelBlock" v-if="isChapterAdmin()">
        <v-flex tag="h2">Create New Events</v-flex>
        <v-flex pa-2 class="chapter-events">
            <v-flex v-if="isChapterAdmin()">                
                <v-btn
                    class="primary_btn small ma-0 chapter-events__create-new-event mt-3"
                    data-qe-id="chapter-event_create-new-event_btn"
                    @click="openLink(`${appCommonConstants.CREATE_NEW_EVENT_GOTO_LINK}`)">
                    {{appCommonConstants.CREATE_NEW_EVENT}}
                </v-btn>
            </v-flex>
        </v-flex>
    </v-card>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import { storeGetters } from '@/store/storeGetters.constant';
    import { appCommonConstants, userRoles, routerNames } from '@/components/appCommon.constants';

    export default {
        name: "ChapterEventRightSidebar",
        data() {
            return {
                appCommonConstants,
                userRoles,
                routerNames,
            };
        },
        methods: {
            openLink(link) {
                if (this.isMobileAppBrowser) {
                    window.location.href = link;
                    return false;
                }
                window.open(link, '_blank');
                return false;
            },
            createCEvent() {
                this.$router.push({
                    name: 'ChapterEvent',
                    path: '/chapter-event',
                    params: {
                        communityId: this.$route.params ? this.$route.params.communityId : '',
                    },
                });
            },
            isChapterAdmin() {
                return (this.isCommunityAdmin && this.isChapterPage && this.currentCommunityView === userRoles.ADMIN);
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                isCommunityAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
                currentCommunityView: `${storeGetters.currentCommunityView}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            isChapterPage() {
                return this.$route.name === this.routerNames.CHAPTER;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .chapter-events {
        min-height: 80px;
        position: relative;

        &__create-new-event {
            margin: 5px 0px;
        }
    }
</style>
